import { useContext, useEffect, useState } from 'react'
import {
  Row,
  Col,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Button,
  Table,
} from 'reactstrap'
import { useHistory, useParams, Link } from 'react-router-dom'
import Parser from 'html-react-parser'
import MainContainer from '../../components/modules/containers/MainContainer'
import FeedBack from '../../components/visit--detail/FeedBack'
import Preloader from '../../components/modules/loader'
import { deleteVisit } from './../../api/visit'
import VisitContext from '../../store/visitContext'
import UserContext from '../../store/userContext'
import { userRoles } from '../../mock-data/roles'
import { patientHome } from '../../breadcrumRoutes.js'
import './visit-detail.scss'

const Index = () => {
  const { getEachData } = useContext(VisitContext)
  const userCtx = useContext(UserContext)
  const { id } = useParams()
  const [loading, setLoading] = useState(false)
  const history = useHistory()

  const _buildContentList = (title, lists) => {
    return (
      <div>
        <h5>{title}</h5>
        {Parser(lists)}
      </div>
    )
  }

  const deleteData = async (id) => {
    if (await deleteVisit(id)) {
      history.push('/home')
    }
  }

  useEffect(() => {
    async function fetchApi() {
      setLoading(true)
      await getEachData({ column: 'id', value: id })
      setLoading(false)
    }
    fetchApi()
  }, [])

  return (
    <>
      <MainContainer breadcrums={patientHome}>
        {loading && <Preloader />}
        {!loading && (
          <VisitContext.Consumer>
            {({ eachData }) => (
              <Row>
                <Col md={{ size: 6, offset: 3 }}>
                  <Card className="visit-detail">
                    <CardBody className="d-flex flex-column justify-content-start">
                      <CardTitle className="mb-3 " tag="h5">
                        <strong>Visitor</strong> : {eachData?.visitor?.username}
                      </CardTitle>
                      <CardTitle className="mb-3 " tag="h5">
                        <strong>Co Visitor</strong> :{' '}
                        {eachData?.co_visitors?.map(
                          (e) =>
                            `${e.username} (${
                              userRoles.find((role) => role.id === e.role)?.name
                            })` + ','
                        )}
                      </CardTitle>
                      <CardTitle className="mb-3 " tag="h5">
                        <strong>Townships</strong> :{' '}
                        {eachData?.townships?.map(
                          (e) => `${e.short_code}` + ','
                        )}
                      </CardTitle>
                      <CardTitle className="mb-3 " tag="h5">
                        <strong>Date</strong> : {eachData?.date?.substr(0, 10)}
                      </CardTitle>
                      <CardTitle className="mb-3 " tag="h5">
                        <strong>Type of Visit</strong> :{' '}
                        {eachData.type_of_visit == 1 ? 'In Person' : 'Virtual'}
                      </CardTitle>
                      <CardTitle className="mb-3 " tag="h5">
                        <strong>Place of Visit</strong> :{' '}
                        {eachData.place_of_visit}
                      </CardTitle>
                    </CardBody>
                    <CardBody>
                      {eachData.attachment && (
                        <Button
                          outline
                          className="view-btn mb-3"
                          onClick={() => {
                            window.location = eachData.attachment
                          }}
                        >
                          View Attachment{' '}
                        </Button>
                      )}
                      {eachData?.visitor?.role != 3 &&
                        eachData?.visitor?.role != 4 && (
                          <>
                            {eachData.coordination &&
                              _buildContentList(
                                'Coordination',
                                eachData.coordination
                              )}
                            {eachData.program &&
                              _buildContentList('Program', eachData.program)}
                            {eachData.m_and_e &&
                              _buildContentList('M & E', eachData.m_and_e)}
                            {eachData.recommendation &&
                              _buildContentList(
                                'Recommendation',
                                eachData.recommendation
                              )}
                          </>
                        )}
                      {eachData?.visitor?.role != 3 &&
                        eachData?.visitor?.role != 4 && (
                          <Table className="mt-5" bordered>
                            {eachData?.tableData?.map((row, rIndex) => (
                              <tr>
                                {eachData?.tableData[rIndex].map(
                                  (col, cIndex) => (
                                    <td>{col}</td>
                                  )
                                )}
                              </tr>
                            ))}
                          </Table>
                        )}
                    </CardBody>

                    {userCtx.eachData.id === eachData?.visitor?.id && (
                      <CardFooter className="d-flex">
                        <Link to={`/edit-visit/${eachData.id}`}>
                          <Button outline className="add-btn me-2">
                            Edit
                          </Button>
                        </Link>
                        <Button
                          outline
                          color="danger"
                          onClick={() => deleteData(eachData.id)}
                        >
                          Delete
                        </Button>
                      </CardFooter>
                    )}
                  </Card>
                  <FeedBack visit_id={id} />
                </Col>
              </Row>
            )}
          </VisitContext.Consumer>
        )}
      </MainContainer>
    </>
  )
}

export default Index
